module.exports = __webpack_public_path__ + "static/media/sild.2743710d.mp3";